






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListArea } from '@/components/config'

// services
import { AreaService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { AreaForm, AreaModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditArea from './modalCreateEdit.vue'

const newItem: AreaForm = {
  name: '',
  description: '',
  is_active: true
}

@Component({
  name: 'AreasIndex',
  components: {
    PageHeader,
    TableListArea,
    ModalCreateEditArea
  }
})
export default class AreasIndex extends Vue {
  showModal = false
  area: AreaForm = newItem
  title = 'Areas'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Areas',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.area = newItem
    this.showModal = true
  }

  editItem (item: AreaModel) {
    this.area = {
      name: item.name,
      description: item.description,
      is_active: item.is_active
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: AreaModel) {
    const msg = `Seguro que desea eliminar el Area: ${item.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await AreaService.delete(item.id)
      alerts.success()
      this.tableList.getAreasWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await AreaService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getAreasWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getAreasWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getAreasWithPagination: () => void }
  }

  get itemInit (): AreaForm {
      return newItem
  }
}
